var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox inline left",on:{"click":function($event){return _vm.not(_vm.value)}}},[_c('div',{staticClass:"pointer check-button",class:{active : _vm.value, TA:_vm.isTestAchat}}),_vm._v(" "),_c('div',{staticClass:"pointer check-label grow",class:{TA:_vm.isTestAchat},domProps:{"innerHTML":_vm._s(_vm.label)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8722158","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/simulation/OptionField.vue
// module id = null
// module chunks = 